// extracted by mini-css-extract-plugin
export default {"form":"Login_form__xawx9","input":"Login_input__xEN53"};